import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import environment from '@root/core/src/utils/environment';
import { Colors, StyleSheet, Theme } from '@root/core/src/utils/styles';

export default function FooterDisclaimer({ onlyShowCopyright = false, containerStyles }) {
  const mergedStyles = [styles.container, containerStyles];

  return (
    <div css={mergedStyles}>
      <span
        css={styles.disclaimer}
      >Copyright ROOT {new Date().getFullYear()}. ROOT is a registered servicemark of Root Insurance Company, Columbus, OH.&nbsp;
      </span>
      {!onlyShowCopyright &&
        <>
          <span
            css={[styles.disclaimer, styles.disclaimerAllCaps]}
          >
            <span css={styles.disclaimerTitle}>Disclaimer for quotes:</span> We reserve the right to refuse to quote any individual a premium rate for the insurance advertised herein.&nbsp;
          </span>
          <span
            css={styles.disclaimer}
          >
            <span css={styles.disclaimerTitle}>Disclaimer for coverage:</span> Coverage is available in the event of a covered loss. Exclusions may apply.&nbsp;
          </span>
          <span
            css={styles.disclaimer}
          >Not available in all states.&nbsp;
          </span>
          <span
            css={styles.disclaimer}
          >
            <span css={styles.disclaimerTitle}>Disclaimer for savings:</span> Based on savings reported by actual customers who purchased a new Root policy between October 2019 - July 2020; changes in coverage levels not evaluated.&nbsp;
          </span>
        </>
      }
      <span
        css={styles.disclaimer}
      >
        <span css={styles.disclaimerTitle}>For California residents:</span> Telematics is not used and resulting represented savings are not applicable. Referral program not applicable. Roadside Assistance purchased as separate coverage. Visit
        <a
          css={styles.disclaimerLink}
          href={`${environment.websiteBaseUrl}/califaq/`}
        > joinroot.com/califaq
        </a> for more information.
      </span>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    ...Theme.paragraph2(),
  },
  disclaimer: {
    marginBottom: 5,
  },
  disclaimerAllCaps: {
    textTransform: 'uppercase',
  },
  disclaimerTitle: {
    color: Colors.black(),
    textTransform: 'none',
  },
  disclaimerLink: {
    color: Colors.rootOrange(),
    transition: '200ms ease-in-out',
    '&:hover': {
      color: Colors.nearBlack(),
    },
  },
});

FooterDisclaimer.propTypes = {
  containerStyles: PropTypes.object,
  onlyShowCopyright: PropTypes.bool,
};
